import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function VehicleModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
  isUpdate = false,
  stations = [],
}) {
  const [name, setName] = useState("");
  const [types, setTypes] = useState([]);

  const fetchTypes = async () => {
    const res = await apiRequest({
      path: apiPaths.vehicleTypes,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    } else {
      setTypes(res.results);
    }
  };

  const addType = async (e) => {
    e.preventDefault();
    if (!name) {
      return;
    }
    const res = await apiRequest({
      path: apiPaths.vehicleTypes,
      method: "POST",
      data: {
        title: name,
        title_slug: name,
      },
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    } else {
      setName("");
      setTypes([res, ...types]);
    }
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  return (
    <Modal
      title={isUpdate ? "Update Vehicle" : "Add Vehicle"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={(values) => {
          values.id_type = values.type.value;
          values.status = values.status.value;
          values.id_dock = values.station.value;
          delete values.type;
          delete values.station;
          onSave(values);
        }}
        initialValues={
          Object.keys(data).length
            ? {
                ...data,
                type: {
                  text: data.vehicle_type.title,
                  value: data.vehicle_type.id,
                },
                station: data.dock
                  ? {
                      text: data.dock.name,
                      value: data.dock.id,
                    }
                  : undefined,
                status: { text: data.status, value: data.status },
              }
            : {
                status: { text: "active", value: "active" },
              }
        }
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Vehicle Type"
              name={"type"}
              rules={[
                {
                  required: true,
                  message: `Please select vehicle type!`,
                },
              ]}
            >
              <Select
                placeholder={"Select vehicle type"}
                showSearch
                style={{ width: 280 }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                labelInValue={true}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: "8px 0" }} />
                    <Space align="center" style={{ padding: "0 8px 4px" }}>
                      <Input
                        placeholder="vehicle type title"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      />
                      <Typography.Link
                        onClick={addType}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <PlusOutlined /> Add Type
                      </Typography.Link>
                    </Space>
                  </>
                )}
              >
                {types.map((item, index) => (
                  <Select.Option key={index + "o"} value={item.id}>
                    {item.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Vehicle Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Vehicle Name",
                },
              ]}
            >
              <Input placeholder="Vehicle Name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Vehicle Code"
              name="code"
              rules={[
                {
                  required: true,
                  message: "Please Vehicle Code",
                },
              ]}
            >
              <Input placeholder="Vehicle Code" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Ride Charges"
              name="ride_charges"
              rules={[
                {
                  required: true,
                  message: "Please Charges",
                },
              ]}
            >
              <InputNumber style={{ width: 200 }} placeholder="Rdie Charges" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Dock Station"
              name={"station"}
              rules={[
                {
                  required: true,
                  message: `Please select dock station!`,
                },
              ]}
            >
              <Select
                placeholder={"Select dock station"}
                showSearch
                style={{ width: 280 }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                labelInValue={true}
              >
                {stations.map((item, index) => (
                  <Select.Option key={index + "o"} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Status"
              name={"status"}
              rules={[
                {
                  required: true,
                  message: "Please select Status",
                },
              ]}
            >
              <Select
                labelInValue={true}
                options={[
                  { text: "Active", value: "active" },
                  { text: "Inactive", value: "inactive" },
                ]}
                placeholder="Select Status"
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {isUpdate ? "Save" : "Add"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default VehicleModal;
